import {
	PropositionProductTypeValues,
	PropositionStatus,
	PropositionStatusValues,
} from "@dune/types";
import { Tabs, TabsList, TabsTriggerWithNumber } from "@dune/ui";
import React from "react";
import { ProductTypeTabsSection } from "../../../component/common/ProductTypeTabsSection";
import { useProductTypeTabs } from "../../../component/common/useProductTypeTabs";

interface PropositionFiltersProps {
	statusFilter: PropositionStatusValues | undefined;
	productTypeFilter: PropositionProductTypeValues | undefined;
	onStatusFilterChange: (status: PropositionStatusValues | undefined) => void;
	onProductTypeFilterChange: (
		productType: PropositionProductTypeValues | undefined,
	) => void;
	statusCounts: Record<string, number>;
	productTypeCounts: Record<string, number>;
	searchInput: string;
	onSearchChange: (value: string) => void;
}

export const PropositionFilters: React.FC<PropositionFiltersProps> = ({
	statusFilter,
	productTypeFilter,
	onStatusFilterChange,
	onProductTypeFilterChange,
	statusCounts,
	productTypeCounts,
	searchInput,
	onSearchChange,
}) => {
	const { productTypeTabs, shouldShowProductTypeTabs } =
		useProductTypeTabs(productTypeCounts);

	const statusTabs = [
		{
			value: undefined,
			label: "Toutes",
			count: statusCounts.all || 0,
		},
		{
			value: PropositionStatus.NOUVEAU,
			label: "Nouveau",
			count: statusCounts[PropositionStatus.NOUVEAU] || 0,
		},
		{
			value: PropositionStatus.A_SIGNER,
			label: "À signer",
			count: statusCounts[PropositionStatus.A_SIGNER] || 0,
		},
		{
			value: PropositionStatus.SIGNEE,
			label: "Signée",
			count: statusCounts[PropositionStatus.SIGNEE] || 0,
		},
		{
			value: PropositionStatus.SANS_SUITE,
			label: "Sans suite",
			count: statusCounts[PropositionStatus.SANS_SUITE] || 0,
		},
	];

	return (
		<div className="space-y-4">
			{/* Status Tabs - Classic style */}
			<Tabs
				value={statusFilter || "all"}
				onValueChange={(value) =>
					onStatusFilterChange(
						value === "all" ? undefined : (value as PropositionStatusValues),
					)
				}
			>
				<TabsList>
					{statusTabs.map((tab) => (
						<TabsTriggerWithNumber
							key={tab.value || "all"}
							value={tab.value || "all"}
							variant="compact"
							number={tab.count}
						>
							{tab.label}
						</TabsTriggerWithNumber>
					))}
				</TabsList>
			</Tabs>

			<ProductTypeTabsSection
				productTypeTabs={productTypeTabs}
				productTypeFilter={productTypeFilter}
				onProductTypeFilterChange={onProductTypeFilterChange}
				searchInput={searchInput}
				onSearchChange={onSearchChange}
				searchPlaceholder="Rechercher par référence, chantier, apporteur..."
				shouldShow={shouldShowProductTypeTabs}
			/>
		</div>
	);
};
